import { switcher } from 'reducers/utils';
import { ACTIONS } from '../const';

const { ADD_AURAL_NOTIFICATION, REMOVE_AURAL_NOTIFICATION } = ACTIONS;

export default switcher('', {
    [ADD_AURAL_NOTIFICATION](state, { payload }) {
        return payload;
    },
    [REMOVE_AURAL_NOTIFICATION]() {
        return '';
    },
});



// WEBPACK FOOTER //
// ./src/reducers/aural_notification.js